export const routes = {
    "/:taskId/healthSurveillanceQuestionnaire": {
        title: "Health Surveillance Questionnaire"
    },
    "/:taskId/healthSurveillanceConsultation": {
        title: "Health Surveillance Consultation"
    },
    "/:taskId/healthSurveillanceClinicalNotes": {
        title: "Health Surveillance Clinical Notes"
    },
    "/:taskId/healthSurveillanceCertificate": {
        title: "Health Surveillance & Fitness to Work Outcome Report"
    },
    "/:taskId/createRecall": {
        title: "Create Medical Recall"
    },
    "/:taskId/ppqDeclarationReview": {
        title: "Review PPQ Declaration"
    },
    "/:taskId/havsClinicalAssessmentOfHistoryAndExamination": {
        title: "HAVS Clinical Assessment of History and Examination"
    },
    "/:taskId/fastTrackPitPupMedicalForm": {
        title: "Fast Track Pit/Pup Medical Form"
    }
};
